import { Modal } from "antd";
import GradientButton from "../../../component/common/GradientButton";
import { appRoot } from "../../../util/constant/CONSTANTS";
import { useNavigate } from "react-router-dom";

const ErrorModal = ({ open, onClose, errorData = {}, teams = {} }) => {
  const navigate = useNavigate();
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      closeIcon={false}
      centered
      maskClosable={false}
      style={{ zoom: 0.9 }}
      title="Post Errors"
      width={700}
      styles={{
        body: { maxHeight: "80vh", overflowY: "auto", paddingRight: 12 },
      }}
    >
      <div className="space-y-6 mt-4">
        {Object.entries(errorData).map(([teamId, error]) => (
          <div key={teamId} className="border-b">
            <div level={5} className="!mb-2 text-[#a855f7] text-base font-bold">
              {teams[teamId]?.name || `Team ID: ${teamId}`}
            </div>

            {typeof error === "string" ? (
              <div className="text-red-600">• {error}</div>
            ) : (
              Object.entries(error).map(([platform, messages]) => (
                <div key={platform} className="mt-2">
                  <div className="text-sm font-semibold capitalize">
                    {platform?.toLowerCase()}
                  </div>
                  <ul className="list-disc list-inside text-red-600">
                    {messages?.map((msg, idx) => (
                      <li key={idx}>{msg}</li>
                    ))}
                  </ul>
                </div>
              ))
            )}
          </div>
        ))}
      </div>

      {/* Fixed Close Button */}
      <div className="mt-6 pt-4 border-t flex justify-end sticky bottom-0 bg-white">
        <GradientButton
          className="w-1/2 "
          buttonText={"Go to Home"}
          onClick={() => navigate(appRoot)}
        />
      </div>
    </Modal>
  );
};

export default ErrorModal;
